import { useEffect, useState } from "react";

/**
 * Tiny pub/sub for the global VIP lead-capture modal.
 *
 * Anywhere in the app:
 *   import { openVipModal } from "@/lib/vipModal";
 *   <button onClick={() => openVipModal("interested")}>Reserve VIP Spot</button>
 *
 * Mount <GlobalVipModal /> ONCE in App.js — it listens for the event and
 * renders the FoundingLeadModal.
 */
const EVT = "lh:open-vip-modal";

export function openVipModal(tier = "interested", source = "global") {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVT, { detail: { tier, source } }));
}

export function useVipModalListener() {
  const [state, setState] = useState({ open: false, tier: "interested", source: "global" });
  useEffect(() => {
    const handler = (e) => {
      setState({ open: true, tier: e.detail?.tier || "interested", source: e.detail?.source || "global" });
    };
    window.addEventListener(EVT, handler);
    return () => window.removeEventListener(EVT, handler);
  }, []);
  const close = () => setState((s) => ({ ...s, open: false }));
  return { ...state, close };
}
